module.exports = __webpack_public_path__ + "static/img/our-people-we-live-heforshe.ed0dcff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/our-people-we-live-heforshe.png
// module id = iiUj
// module chunks = 0